import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd } from '@/components/UI/svg/mm100';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.listD} listD1`}>
            <div className="kit-inter">
                <div className="kit-ms1">{t('presale.product.listD1_ms1')}</div>
                <div className="kit-ms2">{t('presale.product.listD1_ms2')}</div>
                <div className="kit-ms3">{t(locale === 'kr' ? 'presale.product.listD1_ms3_h5' : 'presale.product.listD1_ms3')}</div>
                <div className="more-win-fun" onClick={() => callBack('listD1')}>
                    {t('presale.product.h5_learn_more')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
            </div>
            <div className="kit-img">
                <EFPic name={['listD1.webp', 'listD1.jpg']} className="fullImgs" alt="" />
            </div>
        </div>
    );
}
